module.exports = __webpack_public_path__ + "media/src/images/landing/flags/finish-06ffd961f47932bb5ca40ab60d445170.svg";